import Vue from 'vue'

/**
 * 事件总线
 */
const eventBus = new Vue()

export default eventBus



// WEBPACK FOOTER //
// ./src/components/EventBus.js